/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tradenamerequired2Inputs */

const en_tradenamerequired2 = /** @type {(inputs: Tradenamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade name is required`)
};

const de_tradenamerequired2 = /** @type {(inputs: Tradenamerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsname ist erforderlich`)
};

/**
* | output |
* | --- |
* | "Trade name is required" |
*
* @param {Tradenamerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tradenamerequired2 = /** @type {((inputs?: Tradenamerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tradenamerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tradenamerequired2(inputs)
	return de_tradenamerequired2(inputs)
});
export { tradenamerequired2 as "tradeNameRequired" }